module.exports = __webpack_public_path__ + "media/images/icons/quote-7ea8556b30fe38a81a522ef05bb12096.svg";